import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/mdgvancouver/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Ma Dang Goul Korean Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/mdg-ma-dang-goul-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Ma Dang Goul Korean Yelp"
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/mdg-ma-dang-goul-west-end/menu">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Ma Dang Goul Korean Zomato"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/mdg_vancouver/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Ma Dang Goul Korean Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/mdgvancouver/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Ma Dang Goul Korean Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/mdg-ma-dang-goul-vancouver">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Ma Dang Goul Korean Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/mdg-ma-dang-goul-west-end/menu">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Ma Dang Goul Korean Zomato"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/mdg_vancouver/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Ma Dang Goul Korean Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
